import { Types } from './types'
const initialState = {
    dataBusinessVoucher: {
        rows: [],
        paging: {}
    },
    dataBusinessVoucherSub: {
        rows: [],
        paging: {}
    },
}

const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_BUSINESS_VOUCHER:
            return {
                ...newState,
                dataBusinessVoucher: action.payload
            }
        case Types.SAVE_LIST_BUSINESS_VOUCHER_SUB:
            return {
                ...newState,
                dataBusinessVoucherSub: action.payload
            }
        default:
            return newState
    }
}

export default reducer